__turbopack_context__.v({
  "actions": "V12Sentence-module-scss-module__x__NEG__actions",
  "logo": "V12Sentence-module-scss-module__x__NEG__logo",
  "logoButton": "V12Sentence-module-scss-module__x__NEG__logoButton",
  "prefix": "V12Sentence-module-scss-module__x__NEG__prefix",
  "viewOptions": "V12Sentence-module-scss-module__x__NEG__viewOptions",
  "withWord": "V12Sentence-module-scss-module__x__NEG__withWord",
  "withWordDesktop": "V12Sentence-module-scss-module__x__NEG__withWordDesktop",
  "withWordMobile": "V12Sentence-module-scss-module__x__NEG__withWordMobile",
});
